import prepareDetails from "@helpers/prepareDetails";
import axios from "@common/api/desktop/axios";

export const fetchUserAccessProfiles = async (operatorId, search) => {
  const searchTerm = search === "" ? "#" : search;

  const profiles = await axios.get(
    `/UserAccessProfile/profiles/${operatorId},${encodeURIComponent(
      searchTerm,
    )}`,
  );
  return profiles.data.map((x) => {
    return { key: x.id, value: x.id, text: x.name };
  });
};

export const fetchSecurityUsers = async (operatorId, search) => {
  const searchTerm = search === "" ? "#" : search;
  const response = await axios.get(
    `/Security/users/${operatorId},${encodeURIComponent(searchTerm)}`,
  );
  const profiles = response.data.filter((x) => x.type === "P");

  return profiles.map((parent) => {
    return {
      ...parent,
      children: response.data.filter(
        (child) => child.parent === parent.parent && child.type === "U",
      ),
    };
  });
};

export const fetchSecurityUsersList = async (operatorId, search) => {
  const searchTerm = search === "" ? "#" : search;
  const response = await axios.get(
    `/Security/users/list/${operatorId},${encodeURIComponent(searchTerm)}`,
  );
  return response.data;
};

export const fetchTenants = async () => {
  const response = await axios.get(`/Organisation/compliance/tenants`);
  return response.data;
};

export const fetchSecurityUser = async (userId) => {
  const response = await axios.get(`/Security/user/${userId}`);
  return response.data;
};

export const fetchUserAccessProfile = async (profileId, fromAdmin = true) => {
  const profiles = await axios.get(
    `UserAccessProfile/profile2/${profileId},${fromAdmin}`,
  );
  return profiles.data;
};

export const updateAccessProfile = async (profileId, OperatorId, details) => {
  const payload = {
    Id: profileId,
    OperatorId,
    details: prepareDetails(details),
  };
  const response = await axios.put(`/UserAccessProfile/update`, payload);
  return response.data;
};

export const getAccessProfile = async (operatorId) => {
  const response = await axios.get(`/UserAccessProfile/new2/${operatorId}`);
  return response.data;
};

export const getSecurityUser = async (operatorId, profileId) => {
  const response = await axios.get(
    `/Security/newuser/${operatorId},${profileId}`,
  );
  return response.data;
};

export const resetUserPassword = async (email) => {
  const response = await axios.put(`/Security/ResetPassword/${email}`);
  return response.data;
};

export const updateSecurityUser = async (
  userId,
  OperatorId,
  ProfileId,
  details,
  complete,
) => {
  const payload = {
    id: userId,
    OperatorId,
    ProfileId,
    complete,
    details: prepareDetails(details),
  };
  const response = await axios.put(`/Security/update2/`, payload);
  return response.data;
};

export const getUserDataAccess = async (OperatorId, UserId, AccessType) => {
  const response = await axios.get(
    `/Security/dataaccess/${OperatorId},${UserId},${AccessType}`,
  );
  return response.data;
};

export const updateUserDataAccess = async (
  userId,
  AccessTypeDetails,
  details,
) => {
  const payload = {
    id: userId,
    AccessTypeDetails,
    details: prepareDetails(details),
  };
  const response = await axios.put(`/Security/update/`, payload);
  return response.data;
};
